class Controller {
  constructor(Events, $location, $injector, Sections, $stateParams, Lists) {
    "ngInject";
    this.Lists = Lists;
    this.Events = Events;
    this.$location = $location;
    this.$stateParams = $stateParams;

    this.sections = Sections.settingsSections;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.activeParams = this.$stateParams;

    this.addItemEvent = this.Events.getAddEvent("cities");
    this.filterEvent = this.Events.getFilterEvent("cities");
    this.paginateEvent = this.Events.getPaginateEvent("cities");
    this.CitiesTransforms = $injector.get("CitiesTransforms");
    this.CountryResource = $injector.get("Country");
    this.CityHandler = $injector.get("CityHandler");
    this.currentCity = null;
    this.addCityHiddenFields = {};
  }

  $onInit() {
    this.getAllCountries();
  }

  getAllCountries() {
    this.Lists.all.countries = [];
    this.CountryResource.getAll({
      isCityRequired: false,
      limit: 0,
    }).$promise.then((response) => {
      if (response.hits) {
        this.Lists.all.countries = response.hits.map(
          ({ name: title, _id: name }) => ({
            title,
            name,
          })
        );
      }
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/cities/cities.controller.js